const DEFAULT_BG = '#f3f4f6';
const TEXT_DARK = '#1f2937';
const TEXT_LIGHT = '#ffffff';

function parseColor(input) {
  if (!input || typeof input !== 'string') return null;
  const match = input.trim().match(/^#?([0-9a-f]{6})$/i);
  if (!match) return null;
  const hex = match[1];
  return {
    r: parseInt(hex.slice(0, 2), 16),
    g: parseInt(hex.slice(2, 4), 16),
    b: parseInt(hex.slice(4, 6), 16),
  };
}

function toHex({ r, g, b }) {
  const channel = (c) => Math.round(Math.max(0, Math.min(255, c))).toString(16).padStart(2, '0');
  return `#${channel(r)}${channel(g)}${channel(b)}`;
}

/** Mélange une couleur vers le blanc pour adoucir les teintes vives. */
export function softenColor(input, whiteMix = 0.35) {
  const rgb = parseColor(input);
  if (!rgb) return DEFAULT_BG;
  const mix = Math.max(0, Math.min(1, whiteMix));
  return toHex({
    r: rgb.r + (255 - rgb.r) * mix,
    g: rgb.g + (255 - rgb.g) * mix,
    b: rgb.b + (255 - rgb.b) * mix,
  });
}

export function getRelativeLuminance(hex) {
  const rgb = parseColor(hex);
  if (!rgb) return 1;
  const channel = (c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(rgb.r) + 0.7152 * channel(rgb.g) + 0.0722 * channel(rgb.b);
}

export function getContrastTextColor(bgHex) {
  return getRelativeLuminance(bgHex) > 0.52 ? TEXT_DARK : TEXT_LIGHT;
}

/**
 * Style surface (badge, carte CDF) avec fond adouci et texte contrasté.
 * @param {string|null|undefined} bgColor
 * @param {{ vivid?: boolean }} options — vivid=true pour les couleurs commerciales souvent très saturées
 */
export function getKkpSurfaceStyle(bgColor, { vivid = false } = {}) {
  const backgroundColor = softenColor(bgColor, vivid ? 0.4 : 0.15);
  const color = getContrastTextColor(backgroundColor);
  const isDark = color === TEXT_DARK;

  return {
    backgroundColor,
    color,
    secondary: isDark ? 'rgba(31, 41, 55, 0.78)' : 'rgba(255, 255, 255, 0.88)',
    muted: isDark ? 'rgba(31, 41, 55, 0.62)' : 'rgba(255, 255, 255, 0.72)',
  };
}
